import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { Breadcrumb, Button, Col, Modal, PageHeader, Row } from "antd";
import React, { useEffect, useState } from "react";
import { OrderForm } from "./OrderForm";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import {
  resetState,
  setBilling,
  setCustomer,
  setLoading,
  setOrders,
  setShipping,
} from "../../../store/draftSlice/createDraftSlice";
import { deleteDraft, getOrder } from "../../../store/draftSlice/draftSlice";
import { unwrapResult } from "@reduxjs/toolkit";

export const NewOrder = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const order = useAppSelector((state) => state.newdraft.orders);
  const [Delete, setDelete] = useState(false);
  const [formUnsaved, setFormUnsaved] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (formUnsaved) {
        event.preventDefault();
        event.returnValue = "Leaving this page will delete all unsaved changes.";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [formUnsaved]);

  useEffect(() => {
    if (id) {
      dispatch(setLoading(true));
      dispatch(getOrder(Number(id)))
        .then(unwrapResult)
        .then((res) => {
          console.log({ res });
          dispatch(setOrders(res));
          dispatch(setCustomer(res.customer));
          dispatch(setShipping(res.shipping_address));
          if (res.shipping_address !== res.billing_address) {
            dispatch(setBilling(res.billing_address));
          }
          dispatch(setLoading(false));
        });
    } else {
      dispatch(resetState());
    }
  }, [id]);

  useEffect(() => {
    if (order?.id) {
      setFormUnsaved(true);
    }
  }, [order]);

  return (
    <Row className="page promotions">
      <Modal
        visible={Delete}
        onCancel={() => {
          setDelete(false);
        }}
        title="Delete"
        okText="Delete"
        okButtonProps={{ color: "red" }}
        onOk={() => {
          setFormUnsaved(false);
          order?.id && dispatch(deleteDraft(order?.id));
          navigate(-1);
        }}
      >
        Are you sure you want to delete?
      </Modal>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Breadcrumb>
                <Breadcrumb.Item key="dashboard">Dashboard</Breadcrumb.Item>
                <Breadcrumb.Item key="order">Order</Breadcrumb.Item>
                <Breadcrumb.Item key="new">New</Breadcrumb.Item>
              </Breadcrumb>
              <Col sm={24}>
                <PageHeader
                  title="New Order"
                  className="site-page-header"
                  onBack={() => navigate(-1)}
                  extra={
                    order?.id && [
                      <Button
                        type="primary"
                        style={{ background: "red", border: "None" }}
                        key="delete-btn"
                        onClick={() => {
                          setDelete(true);
                        }}
                      >
                        Delete Draft
                      </Button>,
                    ]
                  }
                />
              </Col>
              <Col sm={24}>
                <OrderForm setUnsaved={setFormUnsaved} />
              </Col>
            </>
          }
        />
      </Routes>
    </Row>
  );
};
